import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

class Footer extends React.Component {
    render() {
        return (<>
            <div className="footer-container">
                <div className="row text-center">
                    <a href="https://www.facebook.com/manicomioshop/" className="social-icon fb" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookF}/></a>
                    <a href="https://www.instagram.com/manicomioshop/" className="social-icon ig" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram}/></a>
                    <a href="https://www.youtube.com/channel/UCehhvt74qn7g0h7lQDrBicQ" className="social-icon yt" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutube}/></a>
                    <p className="follow-text">Síguenos</p>
                    <p><small>&copy; 2021 Manicomio Shop. Design by <a href="https://gcipres.netlify.app/" className="designer-page" target="_blank" rel="noopener noreferrer">gcipres</a></small></p>
                </div>
            </div>
        </>);
    }
}

export default Footer;